import React, { useState } from 'react';
import styles from './Paginator.module.css';
import { Paginator } from 'primereact/paginator';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';

const AIEduPaginator = ({ rows, first, onPageChange, totalRecords }) => {
    const paginatorTemplate = {
        layout: 'RowsPerPageDropdown PrevPageLink CurrentPageReport NextPageLink JumpToPageInput',
        RowsPerPageDropdown: (options) => {
            const dropdownOptions = [
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 50, value: 50 },
                { label: 100, value: 100 },
            ];

            return (
                <React.Fragment>
                    <span className={styles.optionsLabelStyle}>
                        Rows per page:{' '}
                    </span>
                    <Dropdown
                        className={styles.paginator_dropdown}
                        value={options.value}
                        options={dropdownOptions}
                        onChange={options.onChange}
                    />
                </React.Fragment>
            );
        },

        JumpToPageInput: (options) => {
            const { value, props, onChange } = options;
            const [inputValue, setInputValue] = useState(value);

            // @ts-ignore - totalPages is not defined in PaginatorJumpToPageInputOptions
            const totalPages = props.totalPages || 0;

            const handleInputChange = (e) => {
                if (!e.value) return;
                const newPage = Math.max(1, Math.min(e.value, totalPages));
                setInputValue(newPage);
            };

            const handleKeyDown = (e) => {
                if (e.key === 'Enter') {
                    // @ts-ignore
                    onChange({
                        originalEvent: e,
                        value: inputValue,
                    });
                }
            };

            return (
                <InputNumber
                    value={inputValue}
                    defaultValue={value}
                    placeholder='#'
                    min={1}
                    max={totalPages}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    tooltip={'Press Enter to go to page'}
                    tooltipOptions={{ position: 'top', showDelay: 200 }}
                    inputClassName={styles.pageInput}
                />
            );
        },
    };

    return (
        <div className={styles.custom_paginatorStyle}>
            <Paginator
                template={paginatorTemplate}
                first={first}
                rows={rows}
                totalRecords={totalRecords}
                onPageChange={onPageChange}
            />
        </div>
    );
};

export default AIEduPaginator;
